import getShappyInfoImport from './getShappyInfo'
import getShopStatusImport from './getShopStatus'

export const getShappyInfo = getShappyInfoImport
export const getShopStatus = getShopStatusImport



// WEBPACK FOOTER //
// ./src/store/modules/shappy/getters/index.js